// Storage flags
export const STORAGE_APP_ID = 'APP_ID'
export const STORAGE_UUID = 'UUID'
export const STORAGE_TOKEN = 'TOKEN'
export const STORAGE_OPEN_ID = 'OPEN_ID'
export const STORAGE_DEBUG = 'DEBUG'
export const STORAGE_HIDE_CHAPTER_READ_TIPS = 'HIDE_CHAPTER_READ_TIPS'
export const STORAGE_CUSTOM_THEME = 'CUSTOM_THEME'
export const STORAGE_ACTIVITY_MAP = 'ACTIVITY_MAP'
export const STORAGE_DAILY_RED_PACK = 'DAILY_RED_PACK' // 每日天降红包
export const STORAGE_AD_FREE = 'AD_FREE' // 免广告
export const STORAGE_AD_WELFARE = 'AD_WELFARE' // 福利
export const STORAGE_DAILY_DOUBLE_READ_REWARD = 'DAILY_DOUBLE_READ_REWARD' // 双倍阅读奖励

// UserAgent
const ua = navigator.userAgent
export const isIOS = /(ios|ipad|iphone)/i.test(ua) || (ua.includes('macintosh') && 'ontouchend' in document)
export const isAndroid = /android/i.test(ua)
export const isSogou = /sogoumse|sogoumobilebrowser/i.test(ua)
export const isWechat = /micromessenger/i.test(ua)
export const isQQ = /qq\//i.test(ua)
export const isWeibo = /weibo/i.test(ua)
export const isSafari
  = ua.includes('Safari')
  && !ua.includes('Chrome')
  && !ua.includes('Sogou')
  && !ua.includes('CriOS')
  && !ua.includes('QQBrowser')
  && !ua.includes('FingerBrowser')
  && !/firefox|iceweasel|fxios/i.test(ua)

// THEME configs
export const THEME_BACKGROUNDS = ['#F5F5F5', '#EBEBEB', '#F5E9CF', '#D2ECD3', '#F6E6E1'] as const
export const THEME_SIZE_CLASSES = {
  sm: {
    title: 'text-23px font-500',
    content: 'mt-50px text-20px lh-1.7em',
    spacing: 'mt-20px',
  },
  md: {
    title: 'text-27px font-500',
    content: 'mt-57.5px text-23px lh-1.7em',
    spacing: 'mt-23px',
  },
  lg: {
    title: 'text-31px font-500',
    content: 'mt-67.5px text-27px lh-1.7em',
    spacing: 'mt-27px',
  },
  xl: {
    title: 'text-35px font-500',
    content: 'mt-75px text-30px lh-1.7em',
    spacing: 'mt-30px',
  },
} as const

export enum ERROR_PAGE_LEVEL {
  DEFAULT = '0',
  FATAL = '1',
}

// Enums
export enum CHAPTER_LOCK {
  LOCK = 2,
}

// 广告展示形式: 1 为视频广告, 2 为图片广告
export enum AD_TYPE {
  VIDEO = 1,
  IMAGE,
}
// 广告播放完页面状态: 1 为停留当前页, 2 为展示下一页
export enum AD_FINISH_ACTION {
  STAY = 1,
  NEXT,
}
